// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-3d"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20.6604 7L12.0001 2L3.33984 7L3.33984 17L12.0001 22L20.6604 17L20.6604 7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12.0001 20.95L12.0001 12.75M19.751 7.525L12.0001 12L4.24916 7.52501M20.6604 7L12.0001 2L3.33984 7L3.33984 17L12.0001 22L20.6604 17L20.6604 7Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.0001 6L12.0001 8M15.464 14L17.1961 15M8.53625 14L6.8042 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-3d')
export default class Chart3DIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-3d',
    }
  }
}
